import { graphql, PageProps } from 'gatsby'
import React from 'react'

import Layout from '../../components/Layout'
import PageTemplates from '../../components/pages/templates'
import HuntEmbeded from '../../components/pages/templates/HuntEmbeded'

export default function PageGatsbyTemplates(props: PageProps) {
  const { title, description, actions, label } = (props.data as any).content
    .edges[0].node.childTemplatesJson

  return (
    <Layout
      heroLabel={label && <HuntEmbeded />}
      title={title}
      description={description}
      uri={props.uri}
      location={props.location}
      heroCenter
      heroActions={actions}
    >
      <PageTemplates />
    </Layout>
  )
}

export const contentQuery = graphql`
  query TemplatesPageQuery {
    content: allFile(
      filter: { relativePath: { eq: "pages/templates/hero.json" } }
    ) {
      edges {
        node {
          childTemplatesJson {
            title
            description
            actions {
              title
              url
            }
            label
          }
        }
      }
    }
  }
`
